import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Eye, EyeOff, LockKeyhole } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { api, ApiError, queryKeys } from '../lib/api'
import { Button, IconButton, Input } from '../components/ui'

export function LoginPage() {
  const [password, setPassword] = useState('')
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: () => api<{ authenticated: true; absoluteExpiresAt: string }>('/api/auth/login', { method: 'POST', body: JSON.stringify({ password }) }),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.session, data)
      const from = (location.state as { from?: string } | null)?.from
      navigate(from && from !== '/login' ? from : '/', { replace: true })
    },
  })
  const error = mutation.error instanceof ApiError
    ? mutation.error.status === 429
      ? `尝试次数过多，请稍后再试。${typeof mutation.error.details.retryAfterSeconds === 'number' ? ` 约 ${mutation.error.details.retryAfterSeconds} 秒。` : ''}`
      : mutation.error.message
    : mutation.error instanceof Error ? mutation.error.message : ''

  return <main className="login-page">
    <section className="login-card">
      <div className="login-card__art" aria-hidden="true"><span className="bead bead--1" /><span className="bead bead--2" /><span className="bead bead--3" /><span className="bead bead--4" /><span className="bead bead--5" /></div>
      <div className="brand-mark brand-mark--large"><span /><span /><span /><span /></div>
      <span className="eyebrow">私人工作台</span><h1>欢迎回来</h1><p>登录后查看你的库存、作品和采购记录。</p>
      <form onSubmit={(event) => { event.preventDefault(); if (password) mutation.mutate() }}>
        <label className="field"><span className="field__label">登录密码</span><span className="password-input"><LockKeyhole size={18} /><Input type={visible ? 'text' : 'password'} autoComplete="current-password" value={password} maxLength={128} onChange={(event) => setPassword(event.target.value)} autoFocus aria-describedby={error ? 'login-error' : undefined} /><IconButton type="button" label={visible ? '隐藏密码' : '显示密码'} onClick={() => setVisible((value) => !value)}>{visible ? <EyeOff /> : <Eye />}</IconButton></span></label>
        {error && <p className="form-error" id="login-error" role="alert">{error}</p>}
        <Button type="submit" disabled={!password || mutation.isPending}>{mutation.isPending ? '正在登录…' : '安全登录'}</Button>
      </form>
      <small>会话仅保存在 HttpOnly Cookie 中，页面无法读取。</small>
    </section>
  </main>
}
